import React from "react";
import { StripeRequirementsChecker } from "./StripeRequirementsChecker/index.js";

export const AccountRequirementsChecker = (): JSX.Element => {
    return <StripeRequirementsChecker />;
};
